<template lang="pug">
div v {{ version }}
  span.ms-1.capitalize ({{ style }})
</template>

<script setup>
import { computed } from 'vue'
import { useRuntimeConfig } from '#app'
import pkg from '../package.json'

const config = useRuntimeConfig()

// const version = config.public.gitSha || pkg.version;
const version = pkg.version

const style = computed(() => {
  return config.public.style || ''
})
</script>

<style scoped></style>
